import type {NoopType, TimeFnType} from './type';

/**
 * promisify fuction
 */
export const promisify = <T>(cb: NoopType<T>, timeFn: TimeFnType, ms: number = 0) =>
    new Promise<T>((res, rej) => {
        timeFn(async () => {
            try {
                const result = await cb();
                res(result);
            } catch (e) {
                rej(e);
            }
        }, ms);
    });
